// src/components/dashboard/OnboardingProgress.jsx
import { useNavigate } from 'react-router-dom';
import { C } from '../../styles/tokens';

const STEPS = [
  { icon: '📧', label: 'Email Verified',    done: true,  path: null          },
  { icon: '📱', label: 'Phone Verified',    done: true,  path: null          },
  { icon: '🪪', label: 'KYC Approved',      done: true,  path: null          },
  { icon: '📄', label: 'CV Uploaded',       done: true,  path: '/cv-optimizer' },
  { icon: '👤', label: 'Profile Complete',  done: false, path: '/profile'    },
  { icon: '🎯', label: 'First Application', done: false, path: '/opportunities' },
];

export default function OnboardingProgress() {
  const navigate   = useNavigate();
  const completed  = STEPS.filter(s => s.done).length;
  const pct        = Math.round((completed / STEPS.length) * 100);

  return (
    <div className="card" style={{ padding: '20px' }}>
      {/* Top accent */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: `linear-gradient(90deg,${C.magenta},${C.violet})` }} />

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h3 className="syne" style={{ fontSize: '14px', fontWeight: 700 }}>Onboarding</h3>
        <span className="syne" style={{ fontSize: '14px', fontWeight: 800, color: C.magenta }}>{pct}%</span>
      </div>

      {/* Progress bar */}
      <div style={{ height: '6px', borderRadius: '3px', background: 'rgba(255,255,255,.07)', marginBottom: '16px', overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: `linear-gradient(90deg,${C.magenta},${C.violet})`, borderRadius: '3px', transition: 'width 1s ease' }} />
      </div>

      {/* Steps */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
        {STEPS.map((step, i) => (
          <div
            key={i}
            onClick={() => !step.done && step.path && navigate(step.path)}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderRadius: '8px', background: step.done ? 'rgba(0,208,132,.06)' : 'rgba(255,255,255,.02)', border: step.done ? '1px solid rgba(0,208,132,.15)' : '1px solid rgba(255,255,255,.05)', cursor: !step.done && step.path ? 'pointer' : 'default', transition: 'all .2s' }}
            onMouseEnter={e => { if (!step.done && step.path) { e.currentTarget.style.borderColor = 'rgba(254,52,232,.2)'; e.currentTarget.style.background = 'rgba(254,52,232,.05)'; } }}
            onMouseLeave={e => { if (!step.done && step.path) { e.currentTarget.style.borderColor = 'rgba(255,255,255,.05)'; e.currentTarget.style.background = 'rgba(255,255,255,.02)'; } }}
          >
            {/* Status icon */}
            <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: step.done ? 'rgba(0,208,132,.2)' : 'rgba(255,255,255,.07)', border: step.done ? '1px solid rgba(0,208,132,.3)' : '1px solid rgba(255,255,255,.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', flexShrink: 0 }}>
              {step.done ? '✓' : step.icon}
            </div>
            <span style={{ fontSize: '12.5px', fontWeight: 600, color: step.done ? 'rgba(255,255,255,.65)' : 'rgba(255,255,255,.45)', flex: 1, textDecoration: step.done ? 'line-through' : 'none', textDecorationColor: 'rgba(255,255,255,.2)' }}>
              {step.label}
            </span>
            {!step.done && step.path && (
              <span style={{ fontSize: '10px', color: C.magenta, fontWeight: 700 }}>→</span>
            )}
          </div>
        ))}
      </div>

      {/* Summary */}
      <p style={{ fontSize: '11px', color: 'rgba(255,255,255,.3)', textAlign: 'center', marginTop: '12px' }}>
        {completed}/{STEPS.length} steps complete
      </p>
    </div>
  );
}
